import React from 'react'
import SbEditable from 'storyblok-react'
import { Container, Row, Column } from 'src/components/UI/Grid/Grid'
import Components from 'src/storyblok/Components'
import { Flex, Box } from 'reflexbox'

import * as styles from './Faq.module.scss'
import { Props } from './types'

const Highlights = ({ blok }: Props): JSX.Element => {
  const { title, items } = blok

  return (
    <SbEditable content={blok}>
      <Container marginBottom={[10, null, null, '4vw']}>
        <Flex justifyContent={['center', null, null, 'center']}>
          <Box width={[1, null, null, null, 1, '60vw']}>
            {title && (
              <Box
                as="h2"
                className={styles.display}
                textAlign={['left', null, null, 'center']}
                marginBottom={[4, null, null, 6]}
              >
                {title}
              </Box>
            )}
          </Box>
        </Flex>
        <Row>
          {items &&
            items.length > 0 &&
            items.map((blok: any) => {
              return (
                <Column key={blok._uid} width={[1, null, null, 6 / 12]}>
                  <Box marginBottom={[4, null, null, 6]}>
                    {React.createElement(Components(blok.component), {
                      blok: blok,
                    })}
                  </Box>
                </Column>
              )
            })}
        </Row>
      </Container>
    </SbEditable>
  )
}

export default Highlights
